import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { radius3Xl, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren } from "react"
import { shouldForwardProp } from "src/common/shouldForwardProp"
import { ContentWrapper } from "../contentWrapper/ContentWrapper"

export interface StageListProps {
	autoHeight?: boolean
	/** applied on inner ContentWrapper, not root element */
	className?: string
}

export const StageList = ({ autoHeight, children, className, ...rest }: PropsWithChildren<StageListProps>) => {
	return (
		<Wrapper $autoHeight={autoHeight} {...rest}>
			<StyledContentWrapper className={className}>{children}</StyledContentWrapper>
		</Wrapper>
	)
}

const StyledContentWrapper = styled(ContentWrapper)`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
	padding-top: ${spacingStaticMd};
	padding-bottom: ${spacingStaticMd};
	border-radius: ${radius3Xl};
`

const Wrapper = styled("div", { shouldForwardProp })<{ $autoHeight?: boolean }>`
	${({ $autoHeight }) =>
		!$autoHeight &&
		css`
			flex-grow: 1;
		`}

	// workaround when there are multiple StageLists within the same container for logical reasons
	& ~ & ${StyledContentWrapper} {
		padding-top: 0;
	}
`
